import { IconInstagramFill } from '@snorose/icons';

export const FOOTER_CONTACT_ITEMS = Object.freeze([
  {
    type: 'email',
    label: 'CONTACT US',
    value: 'snorose1906@gmail.com',
  },
  {
    type: 'bank',
    label: '스노로즈 후원하기',
    value: '신한 100-038-947719',
    accountHolder: '(예금주: 스노로즈)',
  },
]);

export const FOOTER_MENUS = Object.freeze([
  {
    to: '/my-page/service-policy',
    title: '서비스 이용 약관',
  },
  {
    to: '/my-page/privacy-policy',
    title: '개인정보 처리방침',
  },
  {
    to: 'https://www.notion.so/snorose/1147ef0aa3bf8039add2e00a4edd0eb4',
    title: '광고 및 협업 문의',
  },
]);

export const FOOTER_SNS_LINKS = Object.freeze([
  {
    id: 'instagram',
    icon: IconInstagramFill,
    to: 'https://www.instagram.com/snorose1906/',
  },
]);
